import { useState } from "react";

import { SearchBar } from "@/components/search-bar";
import { SegmentedTabs } from "@/components/segmented-tabs";
import { FeaturePageLayout } from "@/features/shared/layout";

import { TrashedAccountsTable } from "./components/TrashedAccountsTable";
import { TrashedBrandsTable } from "./components/TrashedBrandsTable";
import { TrashedRequestsTable } from "./components/TrashedRequestsTable";
import { TrashedUsersTable } from "./components/TrashedUsersTable";

const TRASH_TABS = [
  { id: 0, label: "Requests" },
  { id: 1, label: "Brands" },
  { id: 2, label: "Users" },
  { id: 3, label: "Accounts" },
];

export default function TrashPage() {
  const [inputValue, setInputValue] = useState("");
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (tabId: number) => {
    setSelectedTab(tabId);
    setInputValue("");
  };

  const renderTabContent = () => {
    switch (selectedTab) {
      case 0: {
        return <TrashedRequestsTable search={inputValue} />;
      }
      case 1: {
        return <TrashedBrandsTable search={inputValue} />;
      }
      case 2: {
        return <TrashedUsersTable search={inputValue} />;
      }
      case 3: {
        return <TrashedAccountsTable search={inputValue} />;
      }
    }
  };

  return (
    <div className="p-xl">
      <FeaturePageLayout title="Trash">
        <div className="w-full bg-bg-primary pt-6 pb-4">
          <div className="flex items-center gap-6 px-xl">
            <SearchBar inputValue={inputValue} setInputValue={setInputValue} />

            <SegmentedTabs
              className="flex-shrink-0 h-[44px]"
              onTabChange={handleTabChange}
              selectedTab={selectedTab}
              tabs={TRASH_TABS}
            />
          </div>
        </div>

        {renderTabContent()}
      </FeaturePageLayout>
    </div>
  );
}
